module.exports = __webpack_public_path__ + "static/media/sec_bg.48a9dbcc.png";